import __request__ from "routing/request";
export function listNotifications() {
  return __request__("GET", "/system/notifications", null, {}, {
    "Accept": ["application/json"]
  });
}
export function deleteNotification(notificationType) {
  return __request__("DELETE", `/system/notifications/${notificationType}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function deleteKeyedNotification(notificationType, notificationKey) {
  return __request__("DELETE", `/system/notifications/${notificationType}/${notificationKey}`, null, {}, {
    "Accept": ["application/json"]
  });
}
